module.exports = __webpack_public_path__ + "static/media/logo-selecthealth-color-txt.c03ef1e7.svg";